import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import Select from "react-select";
import { addRestaurantSchema } from "../../../../validations";
import { useAddRestaurant } from "../../../../queryHooks";
import { useStore } from "../../../../zustand/store";
import CS from "../../../../services/commonService";
import PhoneNumber from "../../../common/PhoneNumber";
import { URL } from "../../../../constants/URL";

const AddRestaurant = () => {
	const setLoading = useStore((state) => state.setLoading);
	const navigate = useNavigate();

	//Defining state object for formik
	const [formData] = useState({
		name: "",
		email: "",
		mobile: "",
		businessType: "",
	});

	const { values, errors, handleChange, handleSubmit, touched } = useFormik({
		initialValues: formData,
		validationSchema: addRestaurantSchema,
		onSubmit: (value) => {
			addRestaurant({
				name: value.name?.trim(),
				email: value.email?.trim(),
				mobile: value.mobile,
				business_type: value.businessType?.value,
			});
		},
	});

	const {
		mutateAsync: addRestaurant,
		error: errorAddRestaurant,
		data: dataAddRestaurant,
		isLoading: isLoadingAddRestaurant,
	} = useAddRestaurant();

	useEffect(() => {
		if (dataAddRestaurant) {
			if (dataAddRestaurant.status === "success") {
				navigate(URL.restaurants, { replace: true });
				CS.showSuccessMessage(dataAddRestaurant.message);
			} else if (dataAddRestaurant.status === "fail") {
				CS.showErrorMessage(dataAddRestaurant.message);
			}
		}
	}, [dataAddRestaurant]);

	useEffect(() => {
		if (errorAddRestaurant) {
			CS.showErrorMessage(errorAddRestaurant.response?.data?.message);
		}
	}, [errorAddRestaurant]);

	useEffect(() => {
		setLoading(isLoadingAddRestaurant);
	}, [isLoadingAddRestaurant]);

	return (
		<>
			<form onSubmit={handleSubmit}>
				<div className="card restaurant-card mb-5">
					<div className="modal-header p-0 pb-3 mb-4 w-100">
						<h5 className="box-title modal-title">
							<i className="bx bx-user mr-1"></i> Restaurant Info
						</h5>
					</div>
					<div className="row">
						<div className="col-md-12">
							<div className="row align-items-end">
								<div className="col-md-12">
									<div className="user-title-info user-details">
										<div className="row">
											<div className="form-group col-md-6 mb-md-4 mb-3">
												<label className="mb-0" htmlFor="restaurantName">
													Restaurant Name
												</label>
												<div className="w-100">
													<input
														maxLength="255"
														type="text"
														className="form-control"
														id="name"
														name="name"
														placeholder="Enter restaurant Name"
														value={values.name}
														onChange={handleChange}
													/>
													<span className="text-danger d-block">
														{errors.name && touched.name ? errors.name : null}
													</span>
												</div>
											</div>
											<div className="form-group col-md-6 mb-md-4 mb-3">
												<label className="mb-1" htmlFor="phonelId">
													Phone Number
												</label>
												<PhoneNumber
													value={values.mobile}
													onChange={(val) => {
														let event = {
															target: {
																name: "mobile",
																value: val ? val : "",
															},
														};
														handleChange(event);
													}}
												/>
												<span className="text-danger d-block">
													{errors.mobile && touched.mobile
														? errors.mobile
														: null}
												</span>
											</div>
											<div className="form-group col-md-6 mb-md-4 mb-3">
												<label className="mb-0" htmlFor="emailId">
													Email
												</label>
												<div className="w-100">
													<input
														maxLength="255"
														className="form-control disabled"
														id="email"
														name="email"
														placeholder="Enter email"
														type="text"
														value={values.email}
														onChange={handleChange}
													/>
													<span className="text-danger d-block">
														{errors.email && touched.email
															? errors.email
															: null}
													</span>
												</div>
											</div>
											<div className="form-group col-md-6 mb-md-4 mb-3">
												{/* <div className="col-md-3"> */}
												<label className="mb-1" htmlFor="phonelId">
													Business Type
												</label>
												<Select
													className="default-select"
													placeholder="Select Business Type"
													name="businessType"
													options={[
														{ label: "Individual", value: "INDIVIDUAL" },
														{ label: "Franchise", value: "FRANCHISE" },
													]}
													value={values.businessType}
													onChange={(value) => {
														let event = {
															target: {
																name: "businessType",
																value: value,
															},
														};
														handleChange(event);
													}}
												></Select>
												<span className="text-danger d-block">
													{errors.businessType && touched.businessType
														? errors.businessType
														: null}
												</span>
											</div>
											<div className="col-md-12 mt-4 btn-blocks text-right">
												<button className="btn btn-primary glow-primary mr-4">
													Add
												</button>
												<Link
													className="btn btn-outline-primary"
													to={URL.restaurants}
												>
													Cancel
												</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</>
	);
};

export default AddRestaurant;
